import {
  Col,
  DatePicker,
  Divider,
  Form,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import COLORS from "common/Colors";
import {
  APPROVAL_FILTER_TYPES,
  MONTH_LIST,
  STATUS_CODE,
} from "common/Constants";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  addMonthinDate,
  dateInDetail,
  getinitialdate,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import {
  getMenuList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { EditOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import ApplyTimeOff from "pages/Apply/ApplyTimeOff";

import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import { find, get } from "lodash";
import ViewDocument from "reusableComponent/Popup/viewDocument";
import download from "downloadjs";
import ViewMore from "organisms/ViewMore";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import ApplyAsset from "pages/Apply/ApplyAsset";

dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);

const ActionWrapper = styled.div`
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  gap: 8px;
  justify-content: flex-end;

  /* Show on row hover */
  .ant-table-row:hover & {
    opacity: 1;
  }
`;

const ModalWrap = styled(Modal)`
  .ant-modal-content {
    border-radius: 14px;
    padding: 10px 8px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: 600;
    margin-top: -12px;
  }

  .ant-modal-body {
    padding: 10px 20px 24px;
  }

  /* top right icons */
  .top-icons {
    position: absolute;
    right: 55px;
    top: 18px;
    display: flex;
    gap: 18px;
    font-size: 18px;
    color: #5b6fd6;
    cursor: pointer;
  }

  .close-icon {
    position: absolute;
    right: 20px;
    top: 18px;
    font-size: 18px;
    cursor: pointer;
    color: #666;
  }

  .applied-tag {
    background: #e9ecfb;
    border-radius: 20px;
    padding: 3px 14px;
    font-size: 13px;
    margin-bottom: 18px;
    display: inline-block;
  }
  .applied-tag-red {
    background: #ffebee;
    border-radius: 20px;
    padding: 3px 14px;
    font-size: 13px;
    margin-bottom: 18px;
    display: inline-block;
    color: red;
  }
  .applied-tag-green {
    background: #e8f5e9;
    border-radius: 20px;
    padding: 3px 14px;
    font-size: 13px;
    margin-bottom: 18px;
    display: inline-block;
    color: green;
  }

  .label {
    color: #8b8b8b;
    font-weight: 500;
  }

  .value {
    color: #1f1f1f;
    font-weight: 500;
    // text-align: right;
  }

  .attachment {
    color: #2d53da;
    cursor: pointer;
  }

  .reason-title {
    margin-top: 16px;
    color: #8b8b8b;
    font-weight: 500;
  }

  .reason-text {
    margin-top: 6px;
    color: #1f1f1f;
    line-height: 1.6;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .value {
      text-align: left;
      margin-top: 4px;
    }

    .top-icons {
      right: 45px;
      gap: 12px;
    }

    .ant-modal-body {
      padding: 10px 14px 22px;
    }
  }
`;

const MyAssetsWrap = styled.div`
  .ant-input::placeholder,
  .ant-picker-input > input::placeholder {
    color: #9ca3af !important;
  }

  .ant-select-selection-placeholder {
    color: #9ca3af !important;
  }

  .ant-input,
  .ant-picker,
  .ant-select-selector,
  .ant-btn {
    border-radius: 24px !important;
  }

  .ant-btn {
    width: 100%;
  }
`;

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: wrap;
    overflow: hidden;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const MyAssets = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const userInfo = useSelector(getUserInfo);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const userList = useSelector(getUserList);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const durationType = Form.useWatch("duration_type", form);
  const statusType = Form.useWatch("status", form);
  const pageTitleRef = useRef(null);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [viewData, setViewData] = useState({});
  const [scrollY, setScrollY] = useState(120);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const [previewURL, setPreviewURL] = useState();
  const [CSVDataList, setCSVDataList] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const csvLinkEl = useRef();

  const prepareCSV = async (event, done) => {
    if (data?.length > 0) {
      const csvData = data.map((item) => {
        const baseObj = {
          [t("Ticket ID")]: `AT${item?.ticketid}` || "-",
          [t("Title")]: item?.title || "-",
          [t("Asset Name")]: item?.assetname || "-",
          [t("Applied on")]: item?.applied_on
            ? dayjs(item.applied_on).format("Do MMM YYYY - ddd")
            : "-",
          [t("Status")]: item?.ticket_status || "-",
          [t("Priority")]: item?.priority || "-",
          // [t("Attachment")]: item?.fileName || "-",
        };

        return baseObj;
      });

      setCSVDataList(csvData);

      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(t("No data available to download."));
    }
  };

  function weeks(days, date) {
    var date = new Date(date);
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
  }

  const getData = async () => {
    const { start_date, duration_type, month, end_date } =
      form.getFieldsValue();
    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(
        find(MONTH_LIST, { value: month || dayjs().format("MMMM") }),
        "index",
        0
      )
    );
    const status = form.getFieldValue("status");

    const startDate = getMySqlDate(
      duration_type === 2
        ? startDateOfMonth
        : duration_type === 4
        ? momentDate(addMonthinDate(getinitialdate()))
        : dayjs(start_date).format("YYYY-MM-DD")
    );
    const endDate = getMySqlDate(
      duration_type === 2
        ? lastDateOfMonth
        : duration_type === 3
        ? weeks(7, getMySqlDate(start_date))
        : duration_type === 4
        ? momentDate(addMonthinDate(getKenyanDateTime(), 3))
        : dayjs(end_date).format("YYYY-MM-DD")
    );
    setLoading(true);
    const { code, ticketList } = await CALL_API(
      `assets/asset-ticket/mine?userId=${userInfo?.userid}&statusId=${status}&startDate=${startDate}&endDate=${endDate}`,
      "get"
    );

    if (code === STATUS_CODE.SUCCESS) {
      setData(ticketList || []);
      setLoading(false);
    }
  };

  const handlePreviewClick = async (data) => {
    try {
      const preview = data?.ticket_filename?.split(".")?.pop();
      setLoading(true);

      const { code, url } = await CALL_API(
        `assets/ticket-file/${data?.ticketid}`,
        "get",
        {}
      );

      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(preview)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
          setPreview(false);
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [form, userInfo]);

  const handleOk = async () => {
    const { code, data } = await CALL_API(
      `assets/deleteticket/${viewData?.ticketid}`,
      "delete"
    );
    if (code === STATUS_CODE.SUCCESS) {
      setIsDelete(false);
      setViewData({});
      setDeleteLoading(false);
      setPopupOpen(true);
      setTimeout(() => {
        setPopupOpen(false);
      }, 2000);
      getData();
    } else {
      message.error(t("Something went wrong"));
    }
  };

  useEffect(() => {
    if (!pageTitleRef.current) return;

    const baseOffset = 300;
    const minHeight = 120;

    const calculateScrollY = () => {
      const headerHeight = pageTitleRef.current.offsetHeight;

      const availableHeight = window.innerHeight - headerHeight - baseOffset;

      setScrollY(Math.max(minHeight, availableHeight));
    };

    calculateScrollY();

    const resizeObserver = new ResizeObserver(() => {
      calculateScrollY();
    });

    resizeObserver.observe(pageTitleRef.current);
    window.addEventListener("resize", calculateScrollY);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", calculateScrollY);
    };
  }, []);

  const columns = [
    {
      title: t("Ticket"),
      dataIndex: "ticketid",
      key: "ticketid",
      width: 150,
      render: (ticket) => {
        return `AT${ticket}`;
      },
    },
    {
      title: t("Title"),
      dataIndex: "title",
      key: "title",
      width: 150,
    },

    {
      title: t("Applied on"),
      dataIndex: "applied_on",
      key: "applied_on",
      width: 150,
      render: (date) => {
        return dayjs(date).isValid()
          ? dayjs(date)?.format("Do MMM YYYY - ddd")
          : "-";
      },
    },
    {
      title: t("Attachment"),
      dataIndex: "ticket_filename",
      key: "ticket_filename",
      width: 150,
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            className="text-wrap"
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record);
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Asset Name"),
      dataIndex: "assetname",
      key: "assetname",
      width: 150,
    },
    {
      title: t("Priority"),
      dataIndex: "priority",
      key: "priority",
      width: 150,
      className: "reason-column",
    },
    // {
    //   title: t("Status"),
    //   dataIndex: "ticket_status",
    //   key: "ticket_status",
    //   width: 150,
    //   className: "reason-column",
    // },
    {
      title: t("Status"),
      dataIndex: "ticket_status",
      key: "ticket_status",
      width: 150,
      render: (_, record) => {
        if (record.ticket_status === "Rejected") {
          return (
            <a
              onClick={(e) => {
                e.stopPropagation();

                setExpandedRowKeys((prev) =>
                  prev.includes(record.ticketid)
                    ? prev.filter((id) => id !== record.ticketid)
                    : [...prev, record.ticketid]
                );
              }}
            >
              Reason
            </a>
          );
        }

        if (record.ticket_status === "Resolved") {
          return (
            <a
              onClick={(e) => {
                e.stopPropagation();

                setExpandedRowKeys((prev) =>
                  prev.includes(record.ticketid)
                    ? prev.filter((id) => id !== record.ticketid)
                    : [...prev, record.ticketid]
                );
              }}
            >
              Notes
            </a>
          );
        }

        return record.ticket_status;
      },
    },
    {
      key: "actions",
      width: 100,
      // fixed: "right",
      render: (_, record) => {
        return (
          <ActionWrapper>
            <div className="top-icons">
              {record?.ticket_status === "Open" && (
                <>
                  {Menulist?.find(
                    (item) =>
                      item?.key === "myassets" && item?.permission.create
                  ) && (
                    <Edit
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpen(false);
                        setIsEdit(true);
                        setViewData(record);
                      }}
                    />
                  )}

                  {Menulist?.find(
                    (item) =>
                      item?.key === "myassets" && item?.permission.delete
                  ) && (
                    <Trash
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpen(false);
                        setIsDelete(true);
                        setViewData(record);
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </ActionWrapper>
        );
      },
    },
  ];
  if (statusType === "1") {
    columns.push({
      title: t("Resolved by"),
      dataIndex: "resolved_by",
      key: "resolved_by",
      width: 150,
      render: (text) => {
        return text ? text : "-";
      },
    });
  }
  if (statusType === "2") {
    columns.push({
      title: t("Rejected by"),
      dataIndex: "rejected_by",
      key: "rejected_by",
      width: 150,
      render: (text) => {
        return text ? text : "-";
      },
    });
  }
  const validateDateRange = () => {
    const endDate = dayjs(form.getFieldValue("end_date"));
    const startDate = dayjs(form.getFieldValue("start_date"));
    if (dayjs(startDate).isAfter(endDate)) {
      form.setFieldsValue({
        end_date: startDate,
      });
      getData();
    }
  };

  const validateEndDateRange = () => {
    const startDate = dayjs(form.getFieldValue("start_date"));
    const endDate = dayjs(form.getFieldValue("end_date"));
    if (dayjs(endDate).isBefore(startDate)) {
      form.setFieldsValue({
        start_date: endDate,
      });
      getData();
    }
  };

  return (
    <MyAssetsWrap>
      <div className="page-title" ref={pageTitleRef}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            status: "Open",
            duration_type: 4,
            month: dateInDetail(getKenyanDateTime()).monthName,
            status_id: "4",
            start_date: dayjs(),
            end_date: dayjs(),
          }}
          onValuesChange={getData}
        >
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
              <Form.Item name="status">
                <Select
                  placeholder={t("Status")}
                  options={[
                    { label: t("Open"), value: "Open" },
                    { label: t("In Progress"), value: "In Progress" },
                    { label: t("Rejected"), value: "Rejected" },
                    { label: t("Resolved"), value: "Resolved" },
                  ]}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
              <Form.Item name="duration_type">
                <Select
                  placeholder={t("Select...")}
                  options={APPROVAL_FILTER_TYPES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            {durationType === 1 && (
              <>
                <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
                  <Form.Item name="start_date">
                    <DatePicker
                      placeholder={t("Start date")}
                      format="DD-MM-YYYY"
                      className="w-100"
                      allowClear
                      onChange={validateDateRange}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
                  <Form.Item name="end_date">
                    <DatePicker
                      className="w-100"
                      placeholder={t("End date")}
                      format="DD-MM-YYYY"
                      allowClear
                      onChange={validateEndDateRange}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {durationType === 2 && (
              <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
                <Form.Item name="month">
                  <Select
                    placeholder={t("Select...")}
                    options={MONTH_LIST}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
            )}
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={durationType === 1 ? 8 : durationType === 2 ? 12 : 16}
              className="text-end"
            >
              <ButtonOutlined
                className="mt-0"
                style={{ borderRadius: "2px !important", width: "150px" }}
                onClick={prepareCSV}
                disabled={data.length === 0}
              >
                {t("Export CSV file")}
              </ButtonOutlined>
              <CSVLink
                data={CSVDataList}
                filename={"my assets.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
            </Col>
          </Row>
        </Form>
      </div>
      <Spin spinning={loading}>
        <StyledTable
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ y: scrollY }}
          style={{ minHeight: scrollY + 50 }}
          rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
          expandedRowKeys={expandedRowKeys}
          expandable={{
            expandIcon: () => null, // hide default expand icon

            expandedRowRender: (record) => (
              <div style={{ padding: "12px 20px" }}>
                {record.ticket_status === "Rejected" && (
                  <>
                    <strong>Reason:</strong> {record.rejected_reason || "-"}
                  </>
                )}

                {record.ticket_status === "Resolved" && (
                  <>
                    <strong>Notes:</strong> {record.resolved_notes || "-"}
                  </>
                )}
              </div>
            ),

            rowExpandable: (record) =>
              record.ticket_status === "Rejected" ||
              record.ticket_status === "Resolved",
          }}
          onRow={(record) => ({
            onClick: (e) => {
              e.stopPropagation();
              setOpen(true);
              setViewData(record);
            },
          })}
        />
      </Spin>
      <ModalWrap
        open={open}
        onCancel={() => {
          setOpen(false);
          setViewData({});
        }}
        footer={null}
        centered
        width={520}
        closable={false}
        title={t("Asset Ticket")}
      >
        {/* top icons */}

        <div className="top-icons">
          {viewData?.ticket_status === "Open" ? (
            <>
              <Edit
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                  setIsEdit(true);
                }}
              />

              <Trash
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                  setIsDelete(true);
                }}
              />
            </>
          ) : viewData?.ticket_status === "In Progress" ? (
            <></>
          ) : (
            <div className="applied-tag">
              {t("Applied on")}&nbsp;&nbsp;
              <b className="value">
                {dayjs(viewData?.createdAt).format("Do MMM, YYYY")}
              </b>
            </div>
          )}
        </div>

        <CloseOutlined
          className="close-icon"
          onClick={() => {
            setOpen(false);
            setViewData({});
          }}
        />

        {/* applied tag */}
        {viewData?.ticket_status === "Open" ||
        viewData?.ticket_status === "In Progress" ? (
          <div className="applied-tag mt-2">
            {t("Applied on")}&nbsp;&nbsp;
            <b className="value">
              {dayjs(viewData?.createdAt).format("Do MMM, YYYY")}
            </b>
          </div>
        ) : viewData?.ticket_status === "Rejected" ? (
          <div className="applied-tag-red mt-2">
            {t("Rejected on")}&nbsp;&nbsp;
            <b className="value">
              {dayjs(viewData?.rejected_on).format("Do MMM, YYYY")}
            </b>{" "}
            <Divider type="vertical" /> {t("Rejected by")}&nbsp;&nbsp;
            <b className="value">
              {
                userList?.find((item) => item?.userid === viewData?.rejected_by)
                  ?.fullname
              }
            </b>
          </div>
        ) : (
          <div className="applied-tag-green mt-2">
            {t("Resolved on")}&nbsp;&nbsp;
            <b className="value">
              {dayjs(viewData?.resolved_on).format("Do MMM, YYYY")}
            </b>{" "}
            <Divider type="vertical" /> {t("Resolved by")}&nbsp;&nbsp;
            <b className="value">
              {
                userList?.find((item) => item?.userid === viewData?.resolved_by)
                  ?.fullname
              }
            </b>
          </div>
        )}

        {/* start date */}
        <Row gutter={[8, 14]}>
          <Col xs={24} sm={12}>
            <div className="label">{t("Asset")}</div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="value">{viewData?.assetname}</div>
          </Col>

          {/* end date */}
          <Col xs={24} sm={12}>
            <div className="label">{t("Title")}</div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="value">{viewData?.title}</div>
          </Col>

          {/* total days */}
          <Col xs={24} sm={12}>
            <div className="label">{t("Priority")}</div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="value">{viewData?.priority}</div>
          </Col>

          {/* attachment */}
          <Col xs={24} sm={12}>
            <div className="label">{t("Attachment")}</div>
          </Col>
          <Col xs={24} sm={12}>
            <div
              className="value attachment"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (viewData?.ticket_filename) {
                  setOpen(false);
                  handlePreviewClick(viewData);
                }
              }}
            >
              {viewData?.ticket_filename || "-"}
            </div>
          </Col>
        </Row>

        {/* reason */}
        <div className="reason-title">{t("Description")}</div>
        <div className="reason-text">{viewData?.ticket_description}</div>
        {viewData?.ticket_status === "Resolved" && (
          <>
            <div className="reason-title">{t("Notes")}</div>
            <div className="reason-text">{viewData?.resolved_notes}</div>
          </>
        )}
        {viewData?.ticket_status === "Rejected" && (
          <>
            <div className="reason-title">{t("Reason for Rejection")}</div>
            <div className="reason-text">{viewData?.rejected_reason}</div>
          </>
        )}
      </ModalWrap>
      <ApplyAsset
        open={isEdit}
        onCancel={() => {
          setIsEdit(false);
          setViewData({});
        }}
        data={viewData}
        getData={getData}
      />
      <Modal
        open={isDelete}
        footer={null}
        centered
        closable={false}
        width={420}
        onCancel={() => {
          setIsDelete(false);
          setViewData({});
        }}
      >
        <div className="delete-text">
          {t("Are you sure you want to delete this Ticket?")}
        </div>

        <div className="w-100 text-end mt-3">
          <ButtonOutlined
            onClick={() => {
              setIsDelete(false);
              setViewData({});
            }}
          >
            {t("Cancel")}
          </ButtonOutlined>

          <ButtonFilled loading={deleteLoading} onClick={handleOk}>
            {t("Delete")}
          </ButtonFilled>
        </div>
      </Modal>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type={"success"}
        message={t("Deleted")}
      />
      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
    </MyAssetsWrap>
  );
};

export default MyAssets;
